import { Banner } from '@/components/Banner/Banner';
import { languageStrings } from '@/l18n/de';
import { formatLocalDate } from '@/lib/util';

type Props = {
	holidayEndDate?: string;
};

const BannerSubscriptionOnHoliday = ({ holidayEndDate }: Props) => {
	const formattedEndDate = holidayEndDate ? formatLocalDate(holidayEndDate) : undefined;

	return (
		<Banner className="banner-warning">
			<div className="banner--active-hint">
				<strong>{languageStrings.subscriptionOnHoliday.heading}</strong>
				<span>
					{formattedEndDate
						? languageStrings.subscriptionOnHoliday.explanation(formattedEndDate)
						: languageStrings.subscriptionOnHoliday.explanationWithoutDate}
				</span>
				<a href={`https://${import.meta.env.VITE_APP_DST_ROOT_DOMAIN}`}>
					{languageStrings.buttons.backToStart}
				</a>
				{' / '}
				<a href={import.meta.env.VITE_APP_SELF_SERVICE_URL}>
					{languageStrings.buttons.mySubscriptions}
				</a>
			</div>
		</Banner>
	);
};

export { BannerSubscriptionOnHoliday };
